import { render, staticRenderFns } from "./GameStatisticsScreen.vue?vue&type=template&id=2799c067&"
import script from "./GameStatisticsScreen.vue?vue&type=script&lang=js&"
export * from "./GameStatisticsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports